import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { PublicPasswordDeleteModalProps } from './PublicPasswordDeleteModal.types';

export const renderPublicPasswordDeleteModal = (data: PublicPasswordDeleteModalProps) =>
    openPopupHelper({ popupName: popupNames.PUBLIC_PASSWORD_DELETE_MOBILE, data });
